import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {CommunicationContentModelConverter} from '../../../api/entity/converter/communicationContentModel.converter';
import {CommunicationContentModelModel} from '../../../api/entity/communicationContentModel.model';

@Injectable()
export class CommunicationContentModelDataService
    extends AbstractDataServiceV2<CommunicationContentModelModel, CommunicationContentModelConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: CommunicationContentModelConverter) {
        super('CommunicationContentModel', http, httpUrlGenerator, logger, config, converter);
    }
}
